export default __webpack_public_path__ + "static/media/nba-logo.fb65b6aa.png";